(function () {
  var host = String(window.WHOP_HOST || location.hostname || "").replace(/^www\./i, "");
  if (!host || /myshopify\.com$/i.test(host) || host.indexOf("localhost") !== -1) return;

  var CLICK_KEYS = ["gclid", "gbraid", "wbraid"];
  (function rememberClick() {
    try {
      var q = new URLSearchParams(location.search);
      var found = {};
      CLICK_KEYS.forEach(function (k) { if (q.get(k)) found[k] = q.get(k); });
      if (Object.keys(found).length) localStorage.setItem("alb_click", JSON.stringify({ at: Date.now(), ids: found }));
    } catch (err) {}
  })();

  function clickQuery() {
    try {
      var saved = JSON.parse(localStorage.getItem("alb_click") || "null");
      if (!saved || Date.now() - saved.at > 90 * 864e5) return "";
      var parts = [];
      CLICK_KEYS.forEach(function (k) { if (saved.ids[k]) parts.push(k + "=" + encodeURIComponent(saved.ids[k])); });
      return parts.length ? "?" + parts.join("&") : "";
    } catch (err) {
      return "";
    }
  }

  function base() {
    return window.WHOP_CHECKOUT_BASE || ("https://checkout." + host + "/");
  }

  function displayTitle(title) {
    var t = String(title || "");
    var i = t.lastIndexOf("|");
    return (i === -1 ? t : t.slice(i + 1)).trim();
  }

  function sizedImage(src, width) {
    if (!src) return "";
    src = String(src);
    if (src.indexOf("//") === 0) src = "https:" + src;
    return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
  }

  function encodePayload(payload) {
    try {
      return btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/g, "");
    } catch (err) {
      return "";
    }
  }

  var warmedAt = 0;
  function addLink(rel, href) {
    var link = document.createElement("link");
    link.rel = rel;
    link.href = href;
    (document.head || document.documentElement).appendChild(link);
  }
  function warm() {
    if (Date.now() - warmedAt < 8000) return;
    warmedAt = Date.now();
    var origin = base().replace(/^(https?:\/\/[^\/]+).*$/, "$1");
    [origin, "https://js.whop.com", "https://whop.com"].forEach(function (href) { addLink("preconnect", href); });
  }
  addLink("dns-prefetch", base().replace(/^(https?:\/\/[^\/]+).*$/, "$1"));
  if (/^\/cart\/?$/.test(location.pathname)) warm();
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (/\/cart\/(add|change|update)/.test(entry.name)) warm();
      });
    }).observe({ type: "resource" });
  } catch (err) {}

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" }).then(function (r) {
      if (!r.ok) throw new Error("cart " + r.status);
      return r.json();
    });
  }

  function payloadFrom(cart) {
    var lines = (cart && cart.items) || [];
    var count = 0;
    var subtotal = 0;
    var items = lines.map(function (item) {
      var line = item.final_line_price || item.line_price || 0;
      count += item.quantity;
      subtotal += line;
      return {
        id: item.variant_id,
        h: item.handle,
        t: displayTitle(item.product_title || item.title || ""),
        v: item.variant_title && String(item.variant_title).toLowerCase() !== "default title" ? item.variant_title : "",
        q: item.quantity,
        p: line,
        c: 0,
        i: sizedImage(item.image || (item.featured_image && item.featured_image.url) || "", 240),
      };
    });
    var percent = count >= 4 ? 20 : count >= 3 ? 15 : count >= 2 ? 10 : 0;
    var discount = percent ? Math.floor((subtotal * percent) / 100) : 0;
    return {
      items: items,
      count: count,
      sub: subtotal,
      disc: discount,
      total: subtotal - discount,
      cur: cart.currency || "GBP",
      ct: String(cart.token || "").split("?")[0],
            ctry: (window.Shopify && window.Shopify.country) || "GB",
      up: [],
    };
  }

  var early = null;

  function checkoutUrl(control) {
    var reuse = early && control && early.control === control && Date.now() - early.at < 1500;
    var cart = reuse ? early.promise : fetchCart();
    early = null;
    return cart.then(function (data) {
      var payload = payloadFrom(data);
      if (!payload.items.length) return "";
      var hash = encodePayload(payload);
      return base() + clickQuery() + (hash ? "#c=" + hash : "");
    });
  }

  var CHECKOUT_SEL = "#checkout, [data-whop-checkout], [name='checkout'], a[href*='/checkout'], form[action*='/checkout'] [type='submit']";
  var EXPRESS_SEL = ".shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .additional-checkout-buttons, .accelerated-checkout-block, shop-pay-wallet-button";

  (function hideExpress() {
    var style = document.createElement("style");
    style.textContent = EXPRESS_SEL + "{display:none!important}";
    (document.head || document.documentElement).appendChild(style);
  })();

  function controlFor(target) {
    if (!target || !target.closest) return null;
    return target.closest(CHECKOUT_SEL) || target.closest(EXPRESS_SEL);
  }

  function block(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  var busy = false;
  var busyControl = null;

  function release() {
    busy = false;
    if (busyControl) busyControl.removeAttribute("aria-busy");
    busyControl = null;
  }

  function attempt(control, tries) {
    checkoutUrl(tries ? null : control).then(function (url) {
      if (!url) return release();
      location.href = url;
    }).catch(function () {
      if (tries < 3) setTimeout(function () { attempt(control, tries + 1); }, 400);
      else release();
    });
  }

  function go(control) {
    if (busy) return;
    busy = true;
    busyControl = control || null;
    if (busyControl) busyControl.setAttribute("aria-busy", "true");
    warm();
    attempt(control, 0);
  }

  document.addEventListener("pointerdown", function (event) {
    var control = controlFor(event.target);
    if (!control || busy) return;
    warm();
    early = { control: control, at: Date.now(), promise: fetchCart() };
    early.promise.catch(function () {});
  }, true);

  ["mouseover", "focusin"].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (controlFor(event.target)) warm();
    }, { capture: true, passive: true });
  });

  document.addEventListener("click", function (event) {
    var control = controlFor(event.target);
    if (!control) return;
    block(event);
    go(control);
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    var submitter = event.submitter;
    var action = String(form.getAttribute("action") || "");
    var viaCheckout = (submitter && submitter.matches && submitter.matches(CHECKOUT_SEL)) || action.indexOf("/checkout") !== -1;
    if (!viaCheckout) return;
    block(event);
    go(submitter || null);
  }, true);

  window.addEventListener("pageshow", release);
})();
